import React, { useState } from 'react';
import { NavLink, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../db/firebase.js';
import { CronProvider } from './CronContext.js';
import AdminOverview from './AdminOverview.js';
import AdminNFTIds from './AdminNFTIds.js';
import AdminCron from './AdminCron.js';
import AdminFloor from './AdminFloor.js';
import AdminActivityLog from './AdminActivityLog.js';

const navItems = [
    { to: 'overview', label: 'Overview', icon: '📊' },
    { to: 'nft-ids', label: 'NFT IDs', icon: '🦆' },
    { to: 'cron', label: 'Cron Control', icon: '⚙️' },
    { to: 'floor', label: 'Floor Prices', icon: '📈' },
    { to: 'activity', label: 'Activity Log', icon: '📋' },
];

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleSignOut = async () => {
        await signOut(auth);
        navigate('/admin/login');
    };

    const closeSidebar = () => setSidebarOpen(false);

    const SidebarContent = () => (
        <>
            <div className="admin-sidebar-header">
                <span className="admin-sidebar-title">Yellow Mythics</span>
                <span className="admin-sidebar-sub">Admin Panel</span>
            </div>
            <nav className="admin-nav">
                {navItems.map(item => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        onClick={closeSidebar}
                        className={({ isActive }) =>
                            `admin-nav-item ${isActive ? 'admin-nav-item-active' : ''}`
                        }
                    >
                        <span className="admin-nav-icon">{item.icon}</span>
                        {item.label}
                    </NavLink>
                ))}
            </nav>
            <div className="admin-sidebar-footer">
                <a
                    href="/"
                    className="admin-nav-item"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={closeSidebar}
                >
                    <span className="admin-nav-icon">↗</span>
                    View Site
                </a>
                <button className="admin-nav-item admin-signout-btn" onClick={handleSignOut}>
                    <span className="admin-nav-icon">⏻</span>
                    Sign Out
                </button>
            </div>
        </>
    );

    return (
        <CronProvider>
            <div className="admin-layout">
                {/* Mobile hamburger */}
                <button
                    className="admin-hamburger"
                    onClick={() => setSidebarOpen(o => !o)}
                    aria-label="Toggle menu"
                >
                    ☰
                </button>

                {/* Mobile overlay backdrop */}
                {sidebarOpen && (
                    <div className="admin-sidebar-overlay" onClick={closeSidebar} />
                )}

                {/* Sidebar */}
                <aside className={`admin-sidebar ${sidebarOpen ? 'admin-sidebar-open' : ''}`}>
                    <SidebarContent />
                </aside>

                <main className="admin-main">
                    <Routes>
                        <Route index element={<Navigate to="overview" replace />} />
                        <Route path="overview" element={<AdminOverview />} />
                        <Route path="nft-ids" element={<AdminNFTIds />} />
                        <Route path="cron" element={<AdminCron />} />
                        <Route path="floor" element={<AdminFloor />} />
                        <Route path="activity" element={<AdminActivityLog />} />
                        <Route path="*" element={<Navigate to="overview" replace />} />
                    </Routes>
                </main>
            </div>
        </CronProvider>
    );
};

export default AdminDashboard;
